import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import { FormatTypes } from '../../../../../cra/src/constants/templateDictionaries';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

const getWrapperProperties = {
  [breakpointsMinWidth.tabletLg]: {
    column: {
      isEditor: '1 / span 5',
      isDrive: '1',
      isAccount: '1',
      isSupport: '1',
      isBilling: '1',
      isIris: '1',
      isLearning: '1',
      isFinancials: '1',
      default: '2',
    },
    padding: {
      isEditor: '0 24px 0 0',
      isDrive: '0 0 0 20px',
      isAccount: '0 0 0 20px',
      isSupport: '0 0 0 20px',
      isBilling: '0 0 0 20px',
      isIris: '0 0 0 20px',
      isLearning: '0 0 0 20px',
      isFinancials: '0 0 0 20px',
      default: '0',
    },
    margin: {
      isEditor: '0 24px',
      isDrive: '0',
      isAccount: '0',
      isSupport: '0',
      isBilling: '0',
      isIris: '0',
      isLearning: '0',
      isFinancials: '0',
      default: '0',
    },
  },
  [breakpointsMinWidth.desktopMd]: {
    column: {
      isEditor: '1 / span 5',
      isDrive: '1',
      isAccount: '1',
      isSupport: '1',
      isBilling: '1',
      isIris: '1',
      isLearning: '1',
      isFinancials: '1',
      default: '2',
    },
    padding: {
      isEditor: '0 24px 0 0',
      isDrive: '0 0 0 24px',
      isAccount: '0 0 0 24px',
      isSupport: '0 0 0 24px',
      isBilling: '0 0 0 24px',
      isIris: '0 0 0 24px',
      isLearning: '0 0 0 24px',
      isFinancials: '0 0 0 24px',
      default: '0',
    },
    margin: {
      isEditor: '0 24px',
      isDrive: '0',
      isAccount: '0',
      isSupport: '0',
      isBilling: '0',
      isIris: '0',
      isLearning: '0',
      isFinancials: '0',
      default: '0',
    },
  },
};

const LeftToolbarWrapper = styled.ul`
  grid-column: 2/5;
  list-style: none;
  text-align: left;
  margin: 0;
  padding: 0;
  grid-column: 1;

  ${(props) => {
    const { pathname, formatType } = props;
    const isEditor = pathname.includes('/documents/') && 'isEditor';
    const isDrive = pathname.includes('/drive/') && 'isDrive';
    const isAccount = pathname.includes('/account') && 'isAccount';
    const isSupport = pathname.includes('/support') && 'isSupport';
    const isBilling = pathname.includes('/billings') && 'isBilling';
    const isIris = pathname.includes('/services') && 'isIris';
    const isLearning = pathname.includes('/learn') && 'isLearning';
    const isFinancials =
      pathname.includes('/documents/') &&
      'isFinancials' &&
      formatType === FormatTypes.CAREER_FINANCIALS;
    const path =
      isEditor ||
      isDrive ||
      isAccount ||
      isSupport ||
      isBilling ||
      isIris ||
      isLearning ||
      isFinancials ||
      'default';
    const logoMarginTablet = () => {
      if (pathname.includes('/documents/')) {
        return '0 0 0 24px';
      }
      if (
        isDrive ||
        isAccount ||
        isSupport ||
        isBilling ||
        isIris ||
        isLearning ||
        isFinancials
      ) {
        return '0 0 0 76px';
      }
      return '0 0 0 48px';
    };
    return css`
      ${() => {
        if (
          isDrive ||
          isAccount ||
          isSupport ||
          isBilling ||
          isIris ||
          isLearning ||
          isFinancials
        ) {
          return css`
            display: flex;
            align-items: center;
          `;
        }
        return null;
      }}
      @media ${breakpointsMinWidth.tabletSm} {
        display: flex;
        grid-column: ${pathname.includes('/documents/') ? '1 / span 7' : '1'};
        margin: ${isDrive ||
        isAccount ||
        isSupport ||
        isBilling ||
        isIris ||
        isLearning ||
        isFinancials
          ? '0 0 0 76px'
          : '0 0 0 24px'};
      }

      @media ${breakpointsMinWidth.tabletMd} {
        margin: ${logoMarginTablet()};
        grid-column: ${pathname.includes('/documents/') ? '1 / span 5' : null};
        ${() => {
          if (path === 'default') {
            return css`
              grid-column: 2;
              margin: 0;
            `;
          }
          return css``;
        }}
      }

      @media ${breakpointsMinWidth.tabletLg} {
        grid-column: ${getWrapperProperties[breakpointsMinWidth.tabletLg]
          .column[path]};
        display: flex;
        padding: ${getWrapperProperties[breakpointsMinWidth.tabletLg].padding[
          path
        ]};
        margin: ${getWrapperProperties[breakpointsMinWidth.tabletLg].margin[
          path
        ]};
      }
      @media ${breakpointsMinWidth.desktopMd} {
        grid-column: ${getWrapperProperties[breakpointsMinWidth.desktopMd]
          .column[path]};
        display: flex;
        padding: ${getWrapperProperties[breakpointsMinWidth.desktopMd].padding[
          path
        ]};
        margin: ${getWrapperProperties[breakpointsMinWidth.desktopMd].margin[
          path
        ]};
      }
    `;
  }}
`;
const LeftToolbar = (props) => {
  const { children, pathname, dataTestId } = props;
  return (
    <LeftToolbarWrapper pathname={pathname} data-testid={dataTestId}>
      {children}
    </LeftToolbarWrapper>
  );
};

LeftToolbar.propTypes = {
  children: propTypes.node.isRequired,
  pathname: propTypes.string.isRequired,
};

export default LeftToolbar;
